import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface StatProps {
  label: string;
  /** 数値は必ず等幅で組む */
  value: ReactNode;
  hint?: ReactNode;
  tone?: 'default' | 'brand' | 'alert';
  className?: string;
}

const TONE = {
  default: 'text-ink',
  brand: 'text-brand-700',
  alert: 'text-alert',
} as const;

/** ダッシュボード上部に並ぶ数値タイル */
export function Stat({ label, value, hint, tone = 'default', className }: StatProps) {
  return (
    <div className={cn('flex flex-col gap-2 px-6 py-5', className)}>
      <span className="text-xs text-ink-subtle">{label}</span>
      <span className={cn('font-mono text-2xl', TONE[tone])}>{value}</span>
      {hint ? <span className="text-xs text-ink-subtle">{hint}</span> : null}
    </div>
  );
}

/** 罫線で仕切って横に並べる */
export function StatRow({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'grid border border-line bg-surface-raised [&>*+*]:border-l [&>*+*]:border-line',
        className,
      )}
    >
      {children}
    </div>
  );
}
